import { TableCell } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

import theme from '../theme';

const {
  colors: { tableCellHeadColor, tableCellHeadColorHover },
} = theme;

const TableHeadCell = ({ className, onClick, ...props }) => {
  const { classes, cx } = useStyles(styles);
  return (
    <TableCell
      className={cx(classes.tableHeadCell, onClick && 'clickable', className)}
      onClick={onClick}
      {...props}
    />
  );
};

const styles = ({ fontSizes, spacing }) => ({
  tableHeadCell: {
    fontWeight: 400,
    fontSize: fontSizes(13),
    padding: spacing(1, 2),
    '&.MuiTableCell-head': {
      border: 'none',
      color: tableCellHeadColor,
      textTransform: 'uppercase',
    },
    '&.clickable': {
      cursor: 'pointer',
      '&:hover': {
        color: tableCellHeadColorHover,
        transition: 'all 0.2s ease',
      },
    },
  },
});

TableHeadCell.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default TableHeadCell;
